import MovieCard from "@/components/feature/MovieCard";
import type { MovieItem } from "@/mocks/movies";

export default function RecommendList({ current, pool }: { current: MovieItem; pool: MovieItem[] }) {
  const sameGenre = pool.filter((m) => m.id !== current.id && m.genre === current.genre);
  const sameActor = pool.filter(
    (m) => m.id !== current.id && m.actors.some((a) => current.actors.includes(a)),
  );
  const merged: MovieItem[] = [];
  [...sameGenre, ...sameActor, ...pool].forEach((m) => {
    if (m.id !== current.id && !merged.some((x) => x.id === m.id)) merged.push(m);
  });
  const recommend = merged.slice(0, 3);

  if (recommend.length === 0) return null;

  return (
    <div className="mt-8">
      <h2 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-4">
        <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
        相关推荐
      </h2>
      <div className="grid grid-cols-3 gap-3">
        {recommend.map((m) => (
          <MovieCard key={m.id} item={m} />
        ))}
      </div>
    </div>
  );
}